var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isAbsenceJustified
        ? _c("absence-justified-day-legend", {
            staticClass: "p-4",
            attrs: { withTitle: false },
          })
        : _vm.isAbsenceUnjustified
        ? _c("absence-unjustified-day-legend", { attrs: { withTitle: false } })
        : _vm.isAbsenceConfirmWaiting
        ? _c("absence-confirm-waiting-day-legend", {
            attrs: { withTitle: false },
          })
        : _vm.isVacationsNeedReunion
        ? _c("vacations-need-meeting-day-legend", {
            attrs: { withTitle: false },
          })
        : _vm.isVacationsConfirmWaiting
        ? _c("vacation-confirm-waiting-day-legend", {
            attrs: { withTitle: false },
          })
        : _vm.isVacationsApproved
        ? _c("vacations-approved-day-legend", { attrs: { withTitle: false } })
        : _vm.isDayOff
        ? _c("off-day-legend", { attrs: { withTitle: false } })
        : _vm.isDaySick
        ? _c("sick-day-legend", { attrs: { withTitle: false } })
        : _vm._e(),
      _vm.isWorking && !_vm.isNone
        ? _c("hour-planned-legend", {
            class: _vm.classes,
            attrs: {
              withTitle: false,
              planningBarStyle: _vm.employeePlanningStyle,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }